

class StorefrontAuth {
  constructor() {
    this.storeDomain = '42tgeh-de.myshopify.com';
    this.storefrontToken = 'a330c9c4aea1a661813b7eb784f0c85a';
    this.adminToken = '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'; // Admin API token from your scripts
    this.storefrontApiUrl = `https://${this.storeDomain}/api/2025-07/graphql.json`;
    this.adminApiUrl = `https://${this.storeDomain}/admin/api/2025-07/graphql.json`;
    this.firebaseUrl = 'https://your-firebase-function-url'; // Replace with your Firebase function URL
    this.msg91AuthKey = '464815T0bXEjoNNYB868a0bfa6P1';
    
    // Firebase configuration
    this.firebaseConfig = {
        apiKey: "AIzaSyA69_tyrfXViUCDC3PZB1y41CoKIB7oYAM",
        authDomain: "vivid-union-470419-k4.firebaseapp.com",
        projectId: "vivid-union-470419-k4",
        storageBucket: "vivid-union-470419-k4.firebasestorage.app",
        messagingSenderId: "844950110425",
        appId: "1:844950110425:web:ca6d3aff801005c6db7ec8"
      };
    
    // Firebase instances
    this.firebaseApp = null;
    this.firestore = null;
    this.userManager = null;
    
    // Initialize Firebase
    this.initializeFirebase();
    
    this.storefrontHeaders = {
      'Content-Type': 'application/json',
      'X-Shopify-Storefront-Access-Token': this.storefrontToken
    };
    
    this.adminHeaders = {
      'Content-Type': 'application/json',
      'X-Shopify-Access-Token': this.adminToken
    };
    
    this.createModal();
    this.bindEvents();
  }

  async initializeFirebase() {
    try {
      console.log('Starting Firebase initialization...');
      
      // Check if Firebase is already loaded
      if (typeof firebase === 'undefined') {
        console.log('Firebase not loaded, loading SDK...');
        // Load Firebase SDK dynamically
        await this.loadFirebaseSDK();
        console.log('Firebase SDK loaded successfully');
      } else {
        console.log('Firebase already loaded');
      }
      
      // Initialize Firebase
      console.log('Initializing Firebase app...');
      this.firebaseApp = firebase.initializeApp(this.firebaseConfig);
      console.log('Firebase app initialized:', this.firebaseApp);
      
      this.firestore = firebase.firestore();
      console.log('Firestore initialized:', this.firestore);
      
      // Initialize user manager
      console.log('Creating user manager...');
      this.userManager = this.createFirebaseUserManager(this.firebaseApp, this.firestore);
      console.log('User manager created:', this.userManager);
      
      console.log('✅ Firebase initialized successfully');
    } catch (error) {
      console.error('❌ Error initializing Firebase:', error);
      this.userManager = null;
    }
  }

  async loadFirebaseSDK() {
    return new Promise((resolve, reject) => {
      // Load Firebase using the CDN version that works with regular scripts
      const script = document.createElement('script');
      script.src = 'https://www.gstatic.com/firebasejs/9.23.0/firebase-app-compat.js';
      script.onload = () => {
        const firestoreScript = document.createElement('script');
        firestoreScript.src = 'https://www.gstatic.com/firebasejs/9.23.0/firebase-firestore-compat.js';
        firestoreScript.onload = resolve;
        firestoreScript.onerror = reject;
        document.head.appendChild(firestoreScript);
      };
      script.onerror = reject;
      document.head.appendChild(script);
    });
  }

  // Firebase User Manager Class (defined outside StorefrontAuth class)
  createFirebaseUserManager(firebaseApp, firestore) {
    return {
      app: firebaseApp,
      db: firestore,

      async createUser(userData) {
        try {
          console.log('Creating user in Firebase:', userData);
          console.log('Firebase app:', this.app);
          console.log('Firestore db:', this.db);

          const { firstName, lastName, email, phoneNumber } = userData;
          
          if (!firstName || !lastName || !email || !phoneNumber) {
            throw new Error('Missing required fields: firstName, lastName, email, phoneNumber');
          }

          const uid = userData.uid || this.generateUID();

          const userProfile = {
            uid: uid,
            firstName: firstName,
            lastName: lastName,
            email: email,
            phoneNumber: phoneNumber,
            createdAt: new Date().toISOString(),
            updatedAt: new Date().toISOString()
          };

          // Save user profile
          console.log('Saving user profile to Firebase...');
          await this.db.collection('users').doc(uid).set(userProfile);
          console.log('User profile saved successfully');

          // Create phone lookup entry
          const phoneLookup = {
            uid: uid,
            phoneNumber: phoneNumber,
            firstName: firstName,
            lastName: lastName,
            email: email,
            createdAt: new Date().toISOString()
          };

          console.log('Saving phone lookup to Firebase...');
          await this.db.collection('user_lookup').doc(phoneNumber).set(phoneLookup);
          console.log('Phone lookup saved successfully');

          console.log('User created successfully in Firebase:', uid);

          return {
            success: true,
            uid: uid,
            user: userProfile,
            message: 'User created successfully in Firebase!'
          };

        } catch (error) {
          console.error('Error creating user in Firebase:', error);
          return {
            success: false,
            error: error.message
          };
        }
      },

      async getUserByPhoneNumber(phoneNumber) {
        try {
          console.log('Getting user by phone number from Firebase:', phoneNumber, 'Type:', typeof phoneNumber, 'Length:', phoneNumber.length);

          if (!phoneNumber) {
            throw new Error('Phone number is required');
          }

          // Normalize phone number to handle both formats (10-digit and full number with country code)
          // This ensures compatibility with existing data and new data formats

          // Normalize phone number to handle both formats
          let normalizedPhone = phoneNumber.trim();
          
          // If it's a 10-digit number without country code, add +91
          if (normalizedPhone.length === 10 && !normalizedPhone.startsWith('+')) {
            normalizedPhone = '+91' + normalizedPhone;
          }
          
          // If it's a 10-digit number with 91 prefix but no +, add +
          if (normalizedPhone.length === 12 && normalizedPhone.startsWith('91') && !normalizedPhone.startsWith('+')) {
            normalizedPhone = '+' + normalizedPhone;
          }

          console.log('Normalized phone number for lookup:', normalizedPhone);

          // Method 1: Direct lookup with normalized phone
          const phoneLookupDoc = await this.db.collection('user_lookup').doc(normalizedPhone).get();
          
          if (phoneLookupDoc.exists) {
            const userData = phoneLookupDoc.data();
            console.log('User found via direct lookup:', userData);
            return {
              success: true,
              user: userData,
              found: true
            };
          }

          // Method 2: Query fallback with normalized phone
          const usersQuery = this.db.collection('users').where('phoneNumber', '==', normalizedPhone);
          const querySnapshot = await usersQuery.get();
          
          if (!querySnapshot.empty) {
            const userData = querySnapshot.docs[0].data();
            console.log('User found via query:', userData);
            return {
              success: true,
              user: userData,
              found: true
            };
          }

          // Method 3: Try with original phone number (in case it's stored without country code)
          if (normalizedPhone !== phoneNumber) {
            const originalPhoneLookupDoc = await this.db.collection('user_lookup').doc(phoneNumber).get();
            
            if (originalPhoneLookupDoc.exists) {
              const userData = originalPhoneLookupDoc.data();
              console.log('User found via original phone lookup:', userData);
              return {
                success: true,
                user: userData,
                found: true
              };
            }

            const originalUsersQuery = this.db.collection('users').where('phoneNumber', '==', phoneNumber);
            const originalQuerySnapshot = await originalUsersQuery.get();
            
            if (!originalQuerySnapshot.empty) {
              const userData = originalQuerySnapshot.docs[0].data();
              console.log('User found via original phone query:', userData);
              return {
                success: true,
                user: userData,
                found: true
              };
            }
          }

          console.log('User not found in Firebase');
          return {
            success: true,
            user: null,
            found: false
          };

        } catch (error) {
          console.error('Error getting user by phone number from Firebase:', error);
          return {
            success: false,
            error: error.message
          };
        }
      },

      generateUID() {
        return 'user_' + Date.now() + '_' + Math.random().toString(36).substr(2, 9);
      }
    };
  }

  createModal() {
    const modalHTML = `
      <div id="storefront-auth-modal" class="storefront-auth-modal">
        <div class="storefront-auth-modal__overlay"></div>
        <div class="storefront-auth-modal__content">
          <div class="storefront-auth-modal__header">
            <h2 class="storefront-auth-modal__title">Sign In / Sign Up</h2>
            <button class="storefront-auth-modal__close" onclick="window.StorefrontAuth.closeModal()">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <line x1="18" y1="6" x2="6" y2="18"></line>
                <line x1="6" y1="6" x2="18" y2="18"></line>
              </svg>
            </button>
          </div>
          
          <style>
            #storefront-auth-modal {
              position: fixed !important;
              top: 0 !important;
              left: 0 !important;
              width: 100vw !important;
              height: 100vh !important;
              z-index: 9999 !important;
              display: none !important;
              font-family: inherit !important;
            }
            
            #storefront-auth-modal.active {
              display: block !important;
            }
            
            .storefront-auth-modal__overlay {
              position: absolute !important;
              top: 0 !important;
              left: 0 !important;
              width: 100% !important;
              height: 100% !important;
              background-color: rgba(0, 0, 0, 0.5) !important;
            }
            
            .storefront-auth-modal__content {
              position: fixed !important;
              bottom: 0 !important;
              left: 0 !important;
              width: 100vw !important;
              background: white !important;
              height: 450px !important;
              overflow-y: auto !important;
              border-radius: 12px 12px 0 0 !important;
              box-shadow: 0 -4px 20px rgba(0, 0, 0, 0.15) !important;
              transform: translateY(100%) !important;
              transition: transform 0.3s ease !important;
            }
            
            #storefront-auth-modal.active .storefront-auth-modal__content {
              transform: translateY(0) !important;
            }
            
            .storefront-auth-modal__header {
              display: flex;
              justify-content: space-between;
              align-items: center;
              padding: 16px 20px;
              border-bottom: 1px solid #e5e5e5;
            }
            
            .storefront-auth-modal__title {
              margin: 0;
              font-size: 1.1rem;
              font-weight: 600;
              color: #333;
              font-family: inherit;
            }
            
            .storefront-auth-modal__close {
              background: none;
              border: none;
              cursor: pointer;
              padding: 8px;
              border-radius: 0;
              color: #666;
            }
            
            .storefront-auth-modal__body {
              padding: 20px;
            }
            
            .auth-step {
              display: none;
            }
            
            .auth-step.active {
              display: block;
            }
            
            .storefront-auth-form__label {
              display: block;
              margin-bottom: 4px;
              font-weight: 500;
              color: #333;
              font-family: inherit;
            }
            
            .storefront-auth-form__input,
            input[type="tel"],
            input[type="text"],
            input[type="email"] {
              width: 100%;
              padding: 8px 12px;
              border: 1px solid #ddd;
              border-radius: 0;
              font-size: 14px;
              font-family: inherit;
              box-sizing: border-box;
            }
            
            .storefront-auth-form__input:focus {
              outline: none;
              border-color: #333;
            }
            
            .storefront-auth-form__submit {
              width: 100%;
              padding: 10px 16px;
              background-color: #000;
              color: white;
              border: none;
              border-radius: 0;
              font-size: 14px;
              font-weight: 500;
              cursor: pointer;
              font-family: inherit;
            }
            
            .storefront-auth-form__submit:hover {
              background-color: #333;
            }
            
            .storefront-auth-form__submit:disabled {
              background-color: #ccc;
              cursor: not-allowed;
            }
            
            .storefront-auth-form__errors {
              color: #dc3545;
              font-size: 14px;
              margin-top: 8px;
              display: none;
              font-family: inherit;
            }
            
            .auth-modal__success {
              text-align: center;
              padding: 40px 20px;
            }
            
            .auth-modal__success-icon {
              width: 60px;
              height: 60px;
              margin: 0 auto 20px;
              background-color: #28a745;
              border-radius: 50%;
              display: flex;
              align-items: center;
              justify-content: center;
              color: white;
            }
            
            .auth-modal__success h3 {
              margin: 0 0 10px 0;
              color: #333;
              font-family: inherit;
            }
            
            .auth-modal__success p {
              margin: 0;
              color: #666;
              font-family: inherit;
            }
          </style>
          
          <div class="storefront-auth-modal__body">
            <!-- Phone Number Input -->
            <div id="phone-input-step" class="auth-step active">
              <h3>Enter your phone number</h3>
              <p>We'll send you a verification code</p>
              
              <form id="phone-form" class="storefront-auth-form">
                <div class="storefront-auth-form__group">
                  <div style="display: flex; align-items: center; border: 1px solid #ddd; border-radius: 0;">
                    <span style="padding: 8px 12px; background: #f5f5f5; border-right: 1px solid #ddd; font-size: 14px; color: #333;">+91</span>
                    <input 
                      type="tel" 
                      id="phone" 
                      name="phone" 
                      class="storefront-auth-form__input" 
                      placeholder="Enter 10 digit number"
                      maxlength="10"
                      pattern="[0-9]{10}"
                      style="border: none; border-radius: 0; flex: 1;"
                      required
                    >
                  </div>
                </div>
                
                <button type="submit" class="storefront-auth-form__submit" id="send-otp-btn">
                  Send OTP
                </button>
                
                <div id="phone-errors" class="storefront-auth-form__errors"></div>
              </form>
            </div>
            
            <!-- OTP Verification -->
            <div id="otp-verification-step" class="auth-step">
              <h3>Verify your phone number</h3>
              <p>Enter the 4-digit code sent to <span id="verification-phone"></span></p>
              
              <div id="msg91-otp-widget"></div>
              
              <div id="otp-errors" class="storefront-auth-form__errors"></div>
            </div>
            

            
            <!-- User Creation Modal -->
            <div id="user-creation-step" class="auth-step">
              <h3>Complete your profile</h3>
              
              <form id="user-creation-form" class="storefront-auth-form">
                <div class="storefront-auth-form__group">
                  <label for="firstName" class="storefront-auth-form__label">First Name</label>
                  <input 
                    type="text" 
                    id="firstName" 
                    name="firstName" 
                    class="storefront-auth-form__input" 
                    required
                  >
                </div>
                
                <div class="storefront-auth-form__group">
                  <label for="lastName" class="storefront-auth-form__label">Last Name</label>
                  <input 
                    type="text" 
                    id="lastName" 
                    name="lastName" 
                    class="storefront-auth-form__input" 
                    required
                  >
                </div>
                
                <div class="storefront-auth-form__group">
                  <label for="user-email" class="storefront-auth-form__label">Email</label>
                  <input 
                    type="email" 
                    id="user-email" 
                    name="email" 
                    class="storefront-auth-form__input" 
                    placeholder="your@email.com"
                    required
                  >
                </div>
                
                <button type="submit" class="storefront-auth-form__submit" id="create-user-btn">
                  Create Account
                </button>
                
                <div id="user-creation-errors" class="storefront-auth-form__errors"></div>
              </form>
            </div>
            
            <!-- Success State -->
            <div id="success-step" class="auth-step">
              <div class="auth-modal__success">
                <div class="auth-modal__success-icon">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <polyline points="20,6 9,17 4,12"></polyline>
                  </svg>
                </div>
                <h3>Success!</h3>
                <p id="success-message">Your account has been created successfully.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    `;
    
    document.body.insertAdjacentHTML('beforeend', modalHTML);
  }

  bindEvents() {
    // Phone form submission
    document.getElementById('phone-form').addEventListener('submit', (e) => {
      e.preventDefault();
      this.handlePhoneSubmit();
    });
    
    // User creation form submission
    document.getElementById('user-creation-form').addEventListener('submit', (e) => {
      e.preventDefault();
      this.handleUserCreation();
    });
    
    // Close modal on overlay click
    document.querySelector('.storefront-auth-modal__overlay').addEventListener('click', () => {
      this.closeModal();
    });
  }

  async handlePhoneSubmit() {
    const phone = document.getElementById('phone').value.trim();
    
    if (!this.validatePhone(phone)) {
      this.showError('phone-errors', 'Please enter a valid 10-digit phone number');
      return;
    }
    
    // Add +91 prefix for MSG91
    const fullPhone = '+91' + phone;
    
    this.setLoading('send-otp-btn', true);
    this.clearErrors();
    
    try {
      // Initialize MSG91 OTP widget
      await this.initializeMSG91Widget(fullPhone);
      
      // Switch to OTP verification step (OTP will be sent by MSG91 widget)
      this.switchStep('otp-verification');
      document.getElementById('verification-phone').textContent = phone;
      this.createOTPInputForm();
      
    } catch (error) {
      console.error('OTP initialization error:', error);
      
      // Fallback: manually switch to OTP verification step for testing
      console.log('Using fallback approach...');
      this.switchStep('otp-verification');
      document.getElementById('verification-phone').textContent = phone;
      this.createOTPInputForm();
      this.showSuccess('OTP step loaded (fallback mode)');
      
    } finally {
      this.setLoading('send-otp-btn', false);
    }
  }

  async initializeMSG91Widget(phone) {
    return new Promise((resolve, reject) => {
      // Clear previous widget
      const widgetContainer = document.getElementById('msg91-otp-widget');
      widgetContainer.innerHTML = '';
      
      // Create configuration for MSG91 with exposed methods
      const configuration = {
        widgetId: "35687071784f393536353933",
        tokenAuth: this.msg91AuthKey,
        identifier: phone,
        exposeMethods: true,
        captchaRenderId: 'msg91-captcha', // Optional: for captcha rendering
        success: (data) => {
          // This will be called when verification is complete
          console.log('MSG91 success response', data);
        },
        failure: (error) => {
          console.log('MSG91 failure reason', error);
          this.showError('otp-errors', 'OTP verification failed. Please try again.');
        }
      };
      
      // Create script element for MSG91
      const script = document.createElement('script');
      script.type = 'text/javascript';
      script.onload = () => {
        setTimeout(() => {
          if (window.initSendOTP) {
            window.initSendOTP(configuration);
            
            setTimeout(() => {
              if (window.sendOtp) {
                // Initialize widget but don't auto-send OTP
                console.log('MSG91 widget initialized successfully');
                resolve();
              } else {
                reject(new Error('MSG91 sendOtp method not available'));
              }
            }, 1000);
          } else {
            reject(new Error('MSG91 SDK not loaded properly'));
          }
        }, 500);
      };
      
      script.onerror = () => {
        reject(new Error('Failed to load MSG91 script'));
      };
      
      script.src = 'https://verify.msg91.com/otp-provider.js';
      widgetContainer.appendChild(script);
    });
  }

  sendOTP(phone) {
    // Remove any '+' from phone number as MSG91 requires country code without +
    const cleanPhone = phone.replace('+', '');
    
    if (!window.sendOtp) {
      this.showError('otp-errors', 'OTP service not available. Please try again.');
      return;
    }
    
    window.sendOtp(
      cleanPhone,
      (data) => {
        this.showSuccess('OTP sent successfully!');
        this.switchStep('otp-verification');
        document.getElementById('verification-phone').textContent = phone;
        this.createOTPInputForm();
      },
      (error) => {
        this.showError('otp-errors', 'Failed to send OTP. Please try again.');
      }
    );
  }

  retryOTP() {
    window.retryOtp(
      null, // Use default channel
      (data) => {
        console.log('OTP resent successfully:', data);
        this.showSuccess('OTP resent successfully!');
      },
      (error) => {
        console.log('Error resending OTP:', error);
        this.showError('otp-errors', 'Failed to resend OTP. Please try again.');
      }
    );
  }

  verifyOTP(otpValue) {
    window.verifyOtp(
      otpValue,
      async (data) => {
        console.log('OTP verified successfully:', data);
        
        // After OTP verification, check if customer exists by phone number
        this.checkCustomerAfterOTP();
      },
      (error) => {
        console.log('OTP verification failed:', error);
        this.showError('otp-errors', 'Invalid OTP. Please try again.');
      }
    );
  }

  async checkCustomerAfterOTP() {
    // After OTP verification, check if user exists in Firebase
    const phone = document.getElementById('phone').value.trim();
    const fullPhone = '+91' + phone; // Add country code for consistency
    
    this.setLoading('verify-otp-btn', true);
    this.clearErrors();
    
    try {
      // Step 1: Check if user exists in Firebase
      if (this.userManager) {
        const firebaseUserResult = await this.userManager.getUserByPhoneNumber(fullPhone);
        
        if (firebaseUserResult.success && firebaseUserResult.found) {
          console.log('User found in Firebase:', firebaseUserResult.user);
          
          // User exists in Firebase - try to login directly
          const loginResult = await this.loginExistingUserFromFirebase(firebaseUserResult.user);
          
          if (loginResult.success) {
            // Login successful
            this.showSuccess('Welcome back! You have successfully signed in.');
            this.switchStep('success');
            return;
          } else {
            // Login failed, show user creation form to update details
            console.log('Login failed, showing user creation form');
            this.switchStep('user-creation');
            return;
          }
        } else {
          console.log('User not found in Firebase, will create new user');
        }
      }
      
      // User not found in Firebase - show user creation form
      this.switchStep('user-creation');
      
    } catch (error) {
      this.showError('otp-errors', 'An error occurred. Please try again.');
      console.error('Login error:', error);
    } finally {
      this.setLoading('verify-otp-btn', false);
    }
  }

  async loginExistingUserFromFirebase(firebaseUser) {
    try {
      console.log('Logging in existing user from Firebase:', firebaseUser);
      
      // Use the email from Firebase user to login to Shopify
      const email = firebaseUser.email;
      const password = 'Password123!'; // Default password
      
      // Try to login to Shopify
      const loginResult = await this.loginCustomerWithPassword(email, password);
      
      if (loginResult.success) {
        console.log('Successfully logged in existing user');
        return { success: true, user: firebaseUser };
      } else {
        console.log('Failed to login existing user:', loginResult.error);
        return { success: false, error: loginResult.error };
      }
    } catch (error) {
      console.error('Error logging in existing user:', error);
      return { success: false, error: error.message };
    }
  }

  async directLoginWithPhone(phone) {
    // Use dummy email format to directly log in
    const dummyEmail = `${phone}@${this.storeDomain}`;
    
    try {
      // Try to log in with the dummy email and default password
      const loginResult = await this.loginCustomerWithPassword(dummyEmail, "Password123!");
      
      if (loginResult.success) {
        // Get customer details
        const customerDetails = await this.getCustomerDetails(loginResult.accessToken);
        
        if (customerDetails) {
          console.log('Customer details retrieved:', customerDetails);
        }
        
        return { success: true, customer: customerDetails };
      } else {
        return { success: false, error: loginResult.error };
      }
    } catch (error) {
      console.error('Direct login error:', error);
      return { success: false, error: error.message };
    }
  }

  async loginExistingCustomer(customerData) {
    // Customer exists and we already have the access token
    // Store the token and create Shopify session
    this.storeCustomerToken(customerData.accessToken, customerData.expiresAt);
    
    // Get customer details using Storefront API
    const customerDetails = await this.getCustomerDetails(customerData.accessToken);
    
    if (customerDetails) {
      console.log('Customer details retrieved:', customerDetails);
    }
    
    // Create Shopify session by submitting to login form
    await this.submitShopifyLoginForm(customerData.email, "Password123!");
    
    this.showSuccess('Welcome back! You have successfully signed in.');
    this.switchStep('success');
  }

  async getCustomerDetails(accessToken) {
    const query = `
      query getCustomer($customerAccessToken: String!) {
        customer(customerAccessToken: $customerAccessToken) {
          id
          firstName
          lastName
          email
          phone
          acceptsMarketing
          createdAt
          updatedAt
          addresses {
            id
            firstName
            lastName
            address1
            address2
            city
            province
            country
            zip
            phone
          }
          orders(first: 5) {
            edges {
              node {
                id
                name
                totalPriceSet {
                  shopMoney {
                    amount
                    currencyCode
                  }
                }
                createdAt
                fulfillmentStatus
                financialStatus
              }
            }
          }
        }
      }
    `;

    const variables = {
      customerAccessToken: accessToken
    };

    try {
      const response = await fetch(this.storefrontApiUrl, {
        method: 'POST',
        headers: this.storefrontHeaders,
        body: JSON.stringify({
          query: query,
          variables: variables
        })
      });

      const data = await response.json();
      
      console.log('Customer details response:', data);
      
      if (data.data && data.data.customer) {
        return data.data.customer;
      }
      
      return null;
    } catch (error) {
      console.error('Error getting customer details:', error);
      return null;
    }
  }

  createOTPInputForm() {
    const widgetContainer = document.getElementById('msg91-otp-widget');
    
    // Check if form already exists to prevent duplicates
    if (widgetContainer.querySelector('.otp-input-container')) {
      console.log('OTP form already exists, skipping creation');
      return;
    }
    
    widgetContainer.innerHTML = `
      <div class="otp-input-container">
        <div class="otp-input-group">
          <input type="text" id="otp-input" class="otp-input" placeholder="Enter 4-digit OTP" maxlength="4" />
          <button type="button" id="verify-otp-btn" class="storefront-auth-form__submit">
            Verify OTP
          </button>
        </div>
        <div class="otp-actions">
          <button type="button" id="resend-otp-btn" class="storefront-auth-form__submit secondary">
            Resend OTP
          </button>
          <button type="button" id="change-phone-btn" class="storefront-auth-form__submit secondary">
            Change Phone Number
          </button>
        </div>
        <div id="captcha-container"></div>
      </div>
    `;

    // Add event listeners
    const otpInput = document.getElementById('otp-input');
    const verifyBtn = document.getElementById('verify-otp-btn');
    const resendBtn = document.getElementById('resend-otp-btn');
    const changePhoneBtn = document.getElementById('change-phone-btn');

    // Verify OTP on button click
    verifyBtn.addEventListener('click', () => {
      const otpValue = otpInput.value.trim();
      if (otpValue.length === 4) {
        this.verifyOTP(otpValue);
      } else {
        this.showError('otp-errors', 'Please enter a valid 4-digit OTP.');
      }
    });

    // Verify OTP on Enter key
    otpInput.addEventListener('keypress', (e) => {
      if (e.key === 'Enter') {
        const otpValue = otpInput.value.trim();
        if (otpValue.length === 4) {
          this.verifyOTP(otpValue);
        } else {
          this.showError('otp-errors', 'Please enter a valid 4-digit OTP.');
        }
      }
    });

    // Resend OTP
    resendBtn.addEventListener('click', () => {
      this.retryOTP();
    });

    // Change phone number
    changePhoneBtn.addEventListener('click', () => {
      this.switchStep('phone-input');
    });

    // Focus on OTP input
    otpInput.focus();
  }

  async verifyOTPWithFirebase(accessToken) {
    try {
      const response = await fetch(`${this.firebaseUrl}/verifyOTP`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          authkey: this.msg91AuthKey,
          'access-token': accessToken
        })
      });
      
      const result = await response.json();
      return result;
    } catch (error) {
      console.error('Firebase verification error:', error);
      throw error;
    }
  }

  async checkCustomerExists(phone) {
    // Use dummy email format to check if customer exists
    const dummyEmail = `${phone}@${this.storeDomain}`;
    
    // Try to log in with the dummy email and default password
    const query = `
      mutation customerAccessTokenCreate($input: CustomerAccessTokenCreateInput!) {
        customerAccessTokenCreate(input: $input) {
          customerAccessToken {
            accessToken
            expiresAt
          }
          customerUserErrors {
            code
            message
          }
        }
      }
    `;

    const variables = {
      input: {
        email: dummyEmail,
        password: "Password123!"
      }
    };

    try {
      const response = await fetch(this.storefrontApiUrl, {
        method: 'POST',
        headers: this.storefrontHeaders,
        body: JSON.stringify({
          query: query,
          variables: variables
        })
      });

      const data = await response.json();
      
      console.log('Storefront API response:', data);
      
      // Check if login was successful
      if (data.data && data.data.customerAccessTokenCreate && data.data.customerAccessTokenCreate.customerAccessToken) {
        console.log('Customer exists and can be logged in');
        return { 
          phone: phone, 
          exists: true, 
          email: dummyEmail,
          accessToken: data.data.customerAccessTokenCreate.customerAccessToken.accessToken,
          expiresAt: data.data.customerAccessTokenCreate.customerAccessToken.expiresAt
        };
      }
      
      // Check for login errors
      if (data.data && data.data.customerAccessTokenCreate && data.data.customerAccessTokenCreate.customerUserErrors) {
        const errors = data.data.customerAccessTokenCreate.customerUserErrors;
        for (const error of errors) {
          if (error.message && (
            error.message.includes('Invalid credentials') ||
            error.message.includes('Customer not found')
          )) {
            console.log('Customer does not exist:', error.message);
            return false;
          }
        }
      }
      
      // If we get here, customer doesn't exist
      return false;
    } catch (error) {
      console.error('Error checking customer:', error);
      return false;
    }
  }

  async handleUserCreation() {
    const form = document.getElementById('user-creation-form');
    const formData = new FormData(form);
    const firstName = formData.get('firstName');
    const lastName = formData.get('lastName');
    const email = formData.get('email');
    const phone = document.getElementById('phone').value.trim();
    
    if (!firstName || !lastName || !email) {
      this.showError('user-creation-errors', 'Please fill in all required fields');
      return;
    }
    
    // Add +91 prefix to phone number
    const fullPhone = '+91' + phone;
    
    this.setLoading('create-user-btn', true);
    this.clearErrors();
    
    try {
      console.log('Starting user creation process...');
      
      // Ensure Firebase is initialized
      if (!this.userManager) {
        console.log('Firebase not initialized, attempting to initialize...');
        await this.initializeFirebase();
        
        if (!this.userManager) {
          this.showError('user-creation-errors', 'Failed to initialize Firebase. Please try again.');
          return;
        }
      }
      
      // Step 1: Create user in Firebase
      console.log('Step 1: Creating user in Firebase...');
      console.log('userManager status:', this.userManager ? 'Available' : 'Not available');
      
      if (this.userManager) {
        const firebaseUserData = {
          firstName: firstName,
          lastName: lastName,
          email: email,
          phoneNumber: fullPhone
        };
        
        console.log('Firebase user data to create:', firebaseUserData);
        
        const firebaseResult = await this.userManager.createUser(firebaseUserData);
        
        console.log('Firebase create result:', firebaseResult);
        
        if (!firebaseResult.success) {
          console.log('⚠️ Firebase user creation failed:', firebaseResult.error);
          console.log('Continuing with Shopify user creation...');
          // Don't return here, continue with Shopify creation
        } else {
          console.log('✅ Step 1 Complete: User created in Firebase:', firebaseResult.uid);
        }
      } else {
        console.log('⚠️ Skipping Firebase user creation - userManager not available');
        console.log('Continuing with Shopify user creation...');
      }
      
      // Step 2: Create user in Shopify
      console.log('Step 2: Creating user in Shopify...');
      console.log('Shopify user data:', { firstName, lastName, email, fullPhone });
      
      const password = 'Password123!';
      const shopifyResult = await this.createCustomerWithPassword(firstName, lastName, email, fullPhone, password);
      
      console.log('Shopify create result:', shopifyResult);
      
      if (!shopifyResult.success) {
        this.showError('user-creation-errors', 'Failed to create user in Shopify: ' + (shopifyResult.error || 'Unknown error'));
        return;
      }
      
      console.log('✅ Step 2 Complete: User created in Shopify');
      
      // Step 3: Get access token
      console.log('Step 3: Getting access token...');
      const loginResult = await this.loginCustomerWithPassword(email, password);
      
      if (!loginResult.success) {
        this.showError('user-creation-errors', 'Account created but failed to get access token: ' + (loginResult.error || 'Unknown error'));
        return;
      }
      
      console.log('✅ Step 3 Complete: Access token obtained');
      
      // Step 4: Login using Shopify button to have customer object visible
      console.log('Step 4: Logging in with Shopify...');
      await this.submitShopifyLoginForm(email, password);
      
      console.log('✅ Step 4 Complete: Shopify login successful');
      
      // All steps completed successfully
      this.showSuccess('Account created successfully! You are now logged in.');
      this.switchStep('success');
      
    } catch (error) {
      this.showError('user-creation-errors', 'An error occurred during account creation. Please try again.');
      console.error('User creation error:', error);
    } finally {
      this.setLoading('create-user-btn', false);
    }
  }

  async createCustomerWithPassword(firstName, lastName, email, phone, password) {
    console.log('createCustomerWithPassword called with:', { firstName, lastName, email, phone });
    
    const query = `
      mutation customerCreate($input: CustomerCreateInput!) {
        customerCreate(input: $input) {
          customer {
            id
            email
            phone
            firstName
            lastName
          }
          customerUserErrors {
            code
            message
          }
        }
      }
    `;

    const variables = {
      input: {
        firstName: firstName,
        lastName: lastName,
        email: email, // Use the actual email from the form
        phone: phone,
        password: password
      }
    };

    console.log('Shopify API variables:', variables);
    console.log('Shopify API URL:', this.storefrontApiUrl);
    console.log('Shopify headers:', this.storefrontHeaders);

    try {
      const response = await fetch(this.storefrontApiUrl, {
        method: 'POST',
        headers: this.storefrontHeaders,
        body: JSON.stringify({
          query: query,
          variables: variables
        })
      });

      const data = await response.json();
      console.log('Shopify API response:', data);

      if (data.errors) {
        const error = data.errors[0];
        let errorMessage = error.message;
        
        console.log('Shopify API error:', error);
        
        if (error.extensions && error.extensions.code === 'THROTTLED') {
          errorMessage = 'Too many attempts. Please wait a few minutes and try again.';
        } else if (error.message.includes('already exists')) {
          errorMessage = 'An account with this email or phone number already exists.';
        }
        
        return {
          success: false,
          error: errorMessage
        };
      }

      if (data.data.customerCreate.customerUserErrors.length > 0) {
        return {
          success: false,
          error: data.data.customerCreate.customerUserErrors[0].message
        };
      }

      return {
        success: true,
        customer: data.data.customerCreate.customer
      };
    } catch (error) {
      throw error;
    }
  }

  generateRandomPassword() {
    return Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);
  }

    async loginCustomerWithPassword(email, password) {
    const query = `
      mutation customerAccessTokenCreate($input: CustomerAccessTokenCreateInput!) {
        customerAccessTokenCreate(input: $input) {
          customerAccessToken {
            accessToken
            expiresAt
          }
          customerUserErrors {
            code
            message
          }
        }
      }
    `;

    const variables = {
      input: {
        email: email,
        password: password
      }
    };

    try {
      const response = await fetch(this.storefrontApiUrl, {
        method: 'POST',
        headers: this.storefrontHeaders,
        body: JSON.stringify({
          query: query,
          variables: variables
        })
      });

      const data = await response.json();

      if (data.errors) {
        return {
          success: false,
          error: data.errors[0].message
        };
      }

      if (data.data.customerAccessTokenCreate.customerUserErrors.length > 0) {
        return {
          success: false,
          error: data.data.customerAccessTokenCreate.customerUserErrors[0].message
        };
      }

      const accessToken = data.data.customerAccessTokenCreate.customerAccessToken.accessToken;
      const expiresAt = data.data.customerAccessTokenCreate.customerAccessToken.expiresAt;

      // Store the access token
      this.storeCustomerToken(accessToken, expiresAt);

      // Create Shopify session by submitting to login form
      await this.submitShopifyLoginForm(email, password);

      return {
        success: true,
        accessToken: accessToken,
        expiresAt: expiresAt
      };
    } catch (error) {
      throw error;
    }
  }

  storeCustomerToken(accessToken, expiresAt) {
    // Store token in localStorage
    localStorage.setItem('customer_access_token', accessToken);
    localStorage.setItem('customer_token_expires', expiresAt);
    localStorage.setItem('customer_login_time', Date.now().toString());
  }

  async submitShopifyLoginForm(email, password) {
    // Create a hidden form and submit it to create Shopify session
    const form = document.createElement('form');
    form.method = 'POST';
    form.action = '/account/login';
    form.style.display = 'none';

    // Add form fields
    const emailInput = document.createElement('input');
    emailInput.type = 'hidden';
    emailInput.name = 'customer[email]';
    emailInput.value = email;
    form.appendChild(emailInput);

    const passwordInput = document.createElement('input');
    passwordInput.type = 'hidden';
    passwordInput.name = 'customer[password]';
    passwordInput.value = password;
    form.appendChild(passwordInput);

    // Add return_to to prevent redirect
    const returnToInput = document.createElement('input');
    returnToInput.type = 'hidden';
    returnToInput.name = 'return_to';
    returnToInput.value = window.location.pathname + window.location.search;
    form.appendChild(returnToInput);

    // Submit the form
    document.body.appendChild(form);
    form.submit();
  }

  resendOTP() {
    this.retryOTP();
  }

  switchStep(stepName) {
    // Hide all steps
    document.querySelectorAll('.auth-step').forEach(step => {
      step.classList.remove('active');
    });
    
    // Show the target step
    switch (stepName) {
      case 'phone-input':
        document.getElementById('phone-input-step').classList.add('active');
        break;
      case 'otp-verification':
        document.getElementById('otp-verification-step').classList.add('active');
        break;
      case 'user-creation':
        document.getElementById('user-creation-step').classList.add('active');
        this.prefillUserCreationForm();
        break;
      case 'success':
        document.getElementById('success-step').classList.add('active');
        break;
    }
  }

  async prefillUserCreationForm() {
    // Try to pre-fill the form with Firebase user data if available
    const phone = document.getElementById('phone').value.trim();
    const fullPhone = '+91' + phone; // Add country code for consistency
    
    if (this.userManager && phone) {
      try {
        const firebaseUserResult = await this.userManager.getUserByPhoneNumber(fullPhone);
        
        if (firebaseUserResult.success && firebaseUserResult.found) {
          const user = firebaseUserResult.user;
          
          // Pre-fill the form fields
          const firstNameInput = document.getElementById('firstName');
          const lastNameInput = document.getElementById('lastName');
          const emailInput = document.getElementById('user-email');
          
          if (firstNameInput && user.firstName) {
            firstNameInput.value = user.firstName;
          }
          if (lastNameInput && user.lastName) {
            lastNameInput.value = user.lastName;
          }
          if (emailInput && user.email) {
            emailInput.value = user.email;
          }
          
          console.log('Form pre-filled with Firebase user data');
          
          // Update button text to indicate this is an update
          const createButton = document.getElementById('create-user-btn');
          if (createButton) {
            createButton.textContent = 'Update Account';
          }
        } else {
          // New user - clear form and set default button text
          const firstNameInput = document.getElementById('firstName');
          const lastNameInput = document.getElementById('lastName');
          const emailInput = document.getElementById('user-email');
          
          if (firstNameInput) firstNameInput.value = '';
          if (lastNameInput) lastNameInput.value = '';
          if (emailInput) emailInput.value = '';
          
          const createButton = document.getElementById('create-user-btn');
          if (createButton) {
            createButton.textContent = 'Create Account';
          }
        }
      } catch (error) {
        console.error('Error pre-filling form:', error);
      }
    }
  }

  validatePhone(phone) {
    // Remove any spaces and check if it's exactly 10 digits
    const cleanPhone = phone.replace(/\s/g, '');
    const phoneRegex = /^[0-9]{10}$/;
    return phoneRegex.test(cleanPhone);
  }

  setLoading(elementId, isLoading) {
    const element = document.getElementById(elementId);
    if (element) {
      if (isLoading) {
        element.disabled = true;
        element.textContent = 'Loading...';
      } else {
        element.disabled = false;
        if (elementId === 'send-otp-btn') {
          element.textContent = 'Send OTP';
        } else if (elementId === 'create-user-btn') {
          element.textContent = 'Create Account';
        }
      }
    }
  }

  showError(elementId, message) {
    const errorElement = document.getElementById(elementId);
    if (errorElement) {
      errorElement.textContent = message;
      errorElement.style.display = 'block';
    }
  }

  clearErrors() {
    document.querySelectorAll('.storefront-auth-form__errors').forEach(error => {
      error.textContent = '';
      error.style.display = 'none';
    });
  }

  showSuccess(message) {
    this.showNotification(message, 'success');
  }

  showNotification(message, type = 'info') {
    const notification = document.createElement('div');
    notification.className = `auth-notification auth-notification--${type}`;
    notification.textContent = message;
    
    document.body.appendChild(notification);
    
    setTimeout(() => {
      notification.classList.add('show');
    }, 100);
    
    setTimeout(() => {
      notification.classList.remove('show');
      setTimeout(() => {
        if (notification.parentNode) {
          notification.parentNode.removeChild(notification);
        }
      }, 300);
    }, 3000);
  }

  openModal() {
    document.getElementById('storefront-auth-modal').classList.add('active');
    document.body.style.overflow = 'hidden';
    this.switchStep('phone-input');
  }

  closeModal() {
    document.getElementById('storefront-auth-modal').classList.remove('active');
    document.body.style.overflow = '';
    this.clearErrors();
    this.switchStep('phone-input');
  }
}

// Initialize the StorefrontAuth class
document.addEventListener('DOMContentLoaded', () => {
  window.StorefrontAuth = new StorefrontAuth();
});

// Global function to open auth modal
window.openAuthModal = () => {
  if (window.StorefrontAuth) {
    window.StorefrontAuth.openModal();
  }
};
